import { IconsProps } from '@/types/shared'

const MakeCopyIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.39474 15C1.96053 15 1.58882 14.8454 1.27961 14.5362C0.970401 14.227 0.815796 13.8553 0.815796 13.4211V3.15789H2.39474V13.4211H15.8158V15H2.39474ZM5.55264 11.8421C5.11843 11.8421 4.74672 11.6875 4.43751 11.3783C4.1283 11.0691 3.97369 10.6974 3.97369 10.2632V1.57895C3.97369 1.14474 4.1283 0.773026 4.43751 0.463816C4.74672 0.154605 5.11843 0 5.55264 0H9.50001L11.079 1.57895H16.6053C17.0395 1.57895 17.4112 1.73355 17.7204 2.04276C18.0296 2.35197 18.1842 2.72368 18.1842 3.15789V10.2632C18.1842 10.6974 18.0296 11.0691 17.7204 11.3783C17.4112 11.6875 17.0395 11.8421 16.6053 11.8421H5.55264ZM5.55264 10.2632H16.6053V3.15789H10.4276L8.84869 1.57895H5.55264V10.2632Z"
                    fill="#626262"
                />
            </svg>
        </div>
    )
}

export default MakeCopyIcons
